<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper" v-loading="loading">
      <!-- 新建活动 -->
      <div class="activity_new">
        <div class="normal_title">活动主题信息</div>
        <div class="operation_btn_box">
          <!-- <div class="operate_btn operate_btn_red" v-if="isBU&&!isOwner&&isBUChangeAssign" @click="gotoConfirmedDetail('/gameplan/quotaWait-confirmed-detail')">调整额度</div>
          <div class="operate_btn operate_btn_white" v-if="isOwner" @click="connectVendor">关联供应商</div>
          <div class="operate_btn operate_btn_white" v-if="themeChannelChecked.length===0&&isOwner" @click="deleteThemeInfo">删除活动主题</div>
          <div class="operate_btn operate_btn_white" v-if="isOwner" @click="addThemeInfo">修改活动主题</div> -->
        </div>
        <div class="pr-box">
          <div class="pr-item space-between">
            <div class="pr-title"> {{themeBasic.themeName}} <span class="pr-level">{{ getOrgLevel }}</span> </div>
            <div> <span class="font-weight-bold">活动时间：</span> {{ themeBasic.themeStartTime | parseTime("{y}-{m}-{d}") }} {{themeBasic.themeStartTime?'-':''}}  {{ themeBasic.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
          </div>
          <div class="flex">
            <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
            <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
          </div>
          <div class="pr-item">
            <div style="margin-right:50px">活动执行数据收集模板 <el-button type="text" style="margin-left:10px;" @click="$refs['ConfigureExecutionData'].handleOpen()">{{ isOwner?'配置':'配置详情' }}</el-button></div>
            <div>
              <span>活动执行手册</span>
              <el-button v-if="themeBasic.manualFileName" type="text" style="margin-left:10px;" @click="openFile('manualFileUri')">{{ themeBasic.manualFileName }}</el-button>
              <el-button type="text" style="margin-left:10px;" v-else>暂无附件</el-button>
            </div>
          </div>
          <!-- <el-row>
            <el-col :span="6">
              活动执行数据收集模板 <el-button type="text" style="margin-left:10px;" @click="$refs['ConfigureExecutionData'].handleOpen()">{{ isOwner?'配置':'配置详情' }}</el-button>
            </el-col >
            <el-col :span="18" v-if="themeBasic.manualFileUri">
              <span>活动执行手册</span>
              <el-button type="text" style="margin-left:10px;" @click="openFile('manualFileUri')">{{ themeBasic.manualFileName }}</el-button>
            </el-col>
          </el-row> -->
          <el-row>
            <el-col :span="24" v-if="themeBasic.skuDTOList&&themeBasic.skuDTOList.length>0">
              活动SKU： <span v-for="(item,index) of themeBasic.skuDTOList" :key="item.skuCode">{{(index===0?"":"、")+ item.skuName }}</span>
              <!-- <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                :content="getSkuName">
                <el-button size="mini" slot="reference">查看</el-button>
              </el-popover> -->
            </el-col>
          </el-row>
        </div>
        <div class="normal_title" v-if="isOwner&&channelAssignVOS.length>0" >BU配额调整待确认</div>
        <div class="activity-new-card channelAssign-box"  v-if="isOwner&&channelAssignVOS.length>0">
          <div class="channelAssign" v-for="item of channelAssignVOS" :key="item.buCode">
            {{getName(item.buName,0) }}
            <div class="channelAssign-item">
              <div v-for="( channel , index ) of item.themeChannelVOList" :key="channel.themeChannelCode">
                {{ getName(channel.themeChannelName,1) }} {{ (item.themeChannelVOList.length===(index+1))?'':',' }}
              </div>
            </div>
            <div class="channelAssign-link" @click="gotoWeb(item.buName,item.buCode)">去审批</div>
          </div>
        </div>
        <div class="normal_title" v-if="isOwner" >活动渠道设置</div>
        <div class="activity-new-card is-hover-shadow channel-box"  v-if="isOwner">
          <el-checkbox-group class="activity_channel_checkbox" v-model="channelCodes">
            <div v-for="item in fullConfig" :key="item.themeChannelCode" :class="themeChannelChecked.indexOf(item.themeChannelCode)!==-1?['check-box-disabled','check-item']:'check-item'">
              <el-checkbox @change="(...arr)=>handleChannelChange(item.themeChannelCode,...arr)" :label="item.themeChannelCode" :disabled="themeChannelChecked.indexOf(item.themeChannelCode)!==-1">
                <div class="activity_channel_checkbox_label">
                  {{item.themeChannelEnName }}<br />{{item.themeChannelName}}
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>

      <div v-for="channelItem of themeChannelCodes" :key="channelItem">
        <ConfigureThemeStyle :channelAssignVOSLength="channelAssignVOS.length" :regionOrgList="regionOrgList" :channelConfig="getChannelConfig(channelItem)" :saveInfo="getSaveInfo(channelItem)" :saveChannelSkuDTOList="getSaveChannelSkuDTOList(channelItem)" @submitDetail="handleReceiveDetail"
          @handleStyleChange="handleStyleChange" :themeId="themeId" :themeBasic="themeBasic"  :isOwner="isOwner" :historyThemeId="historyThemeId" :btmpSkuDTOList="btmpSkuDTOList"/>
      </div>

      <!-- <div class="cross_channel" v-for="item of configItemList" :key="item.themeChannelCode">
        <ConfigItem :saveDetailList1="saveDetailList" @handleSubmit="handleSubmit" :configItem="item" ref="configItemRef" :fullConfig="fullConfig" :assignBuList="assignBuList"
        :assignRegionList="assignRegionList" :assignAreaList="assignAreaList" />
      </div> -->

      <!-- <div class="btn_section">
        <div class="normal_btn btn_bg_white" @click="handleOperation('save')">保存草稿</div>
        <div class="normal_btn btn_bg_red" @click="handleOperation('submit')">提交</div>
      </div> -->
    </div>

    <el-dialog
      title="提示"
      :visible.sync="showConfirmDialog"
      width="30%" >
      <span>是否要{{operateType==='submit'?'提交':'保存'}}当前数据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <ConfigureExecutionData :class="[isOwner?'':'configure-execution']" ref="ConfigureExecutionData" :readonly="!isOwner" :themeId="themeId"></ConfigureExecutionData>
  </div>
</template>
<script>
//import FileUpload from './components/file-upload'
import gameplanApi from "@/api/gameplan";
import { commonUtils } from '@/utils/common'
import ContentHeader from "@/components/content-header";
import { mapGetters,mapState } from 'vuex'
import ConfigureThemeStyle from './components/configure-theme-style.vue'
import ConfigureExecutionData from './components/configure-execution-data'
export default {
  name:"configure-theme-detail",
  components: {
    ContentHeader,
    //FileUpload,
    ConfigureThemeStyle,
    ConfigureExecutionData
  },
  data() {
    var validateThemeTime = (rule, value, callback) => {
      let now = Date.now()
      if (!value||value.length===0) {
        return callback(new Error('请选择执行时间'));
      }else {
        return callback()
      }
      // if(value[0]<now){
      //   return callback(new Error('执行时间不可早于当前时间'));
      // }
    };
    var validateApplyTime = (rule, value, callback) => {
      let now = Date.now()
      if (!value||value.length===0) {
        return callback(new Error('请选择提报时间'));
      }else {
        return callback()
      }
      // if(value[0]<now){
      //   return callback(new Error('提报时间不可早于当前时间'));
      // }
    };
    return {
      detailList:{},
      saveDetailList:[],
      loading:false,
      employeeLevel: '',
      operateType:'',
      themeBasic: {},
      oldThemeTime: [],
      themeTime: [],
      applyTime: [],
      fullConfig: [],
      editRules: {
        themeName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        themeChannelNames: [
          { required: true, message: "请选择活动渠道", trigger: "blur" },
        ],
        themeTime:[
          {validator: validateThemeTime, trigger: 'blur'},
          { required: true, message: "请选择提报时间", trigger: "blur" },
        ],
        applyTime:[
          {validator: validateApplyTime, trigger: 'blur'},
          { required: true, message: "请选择执行时间", trigger: "blur" },
        ]
      },
      themeChannelCodes:[],
      channelCodes:[],
      themeChannelChecked:[],
      annelAssignVOS:[],
      themeChannelNames: [],
      themeInfo:{},
      themeId:'',
      pickerOptions:{
        disabledDate(time) {
            return time.getTime() < Date.now();
          },
      },
      showConfirmDialog:false,
      valid:true,
      errorList:[],
      manualFile: [],
      execTemplate:[],
      dataValid:false,
      saveValid:false,
      rateErrorList:[],
      historyThemeId:'',
      confirmed:true,
      showChangeDateDialog:false,
      channelSkuDTOList:[],
      btmpSkuDTOList:[],
      regionOrgList:[],
      prInfo:'',
      brandInfo:''
    };
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget,
    }),
    ...mapGetters(['userInfo']),
    isOwner(){
      return this.userInfo.employeeCode===this.themeBasic.themeOwnerCode
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getOrgLevel(){
      if(this.themeBasic.orgLevel&&this.themeBasic.orgLevel.length===2) return this.themeBasic.orgLevel.toUpperCase()
      else return 'Region'
    },
    isBUChangeAssign(){
      let result = false
      this.saveDetailList.forEach(detail=>{
        if(detail.curAssignList&&detail.curAssignList.length>0){
          if(detail.curAssignList[0].assignStatus===30) result = true
        }
      })
      return result
    }
  },
  created() {
    this.themeId = this.$route.query.themeId || ''
    this.historyThemeId = this.$route.query.historyThemeId
    this.init()
    this.getGameplanThemeChannelAssign()
  },
  methods: {
    init(){
      this.employeeLevel = this.userInfo.employeeLevel
      this.$store.dispatch('getGameplanDecorateConstructMap')
      this.$store.dispatch('getGameplanDecorateExecDecorateMap')
      this.$store.dispatch('getGameplanDecorateMap')
      if(this.isHQ) this.$store.dispatch('getGameplanCityPoolBaseOrgBuList')
      else if(this.isBU) this.$store.dispatch('getGameplanCityPoolBaseOrgRegionList',{buOrgId:this.userInfo.orgDTO.parentOrgId})
      else if(this.isRegion){
        //this.$store.dispatch('getGameplanCityPoolBaseOrgAreaList',{buOrgId:this.userInfo.orgDTO.parentOrgId,regionOrgId:this.userInfo.orgDTO.orgId})
        this.$store.dispatch('getThemeRegionList')
      }
      //this.$store.dispatch('getGameplanConfigIgniteOptions')
      this.isHistory = this.$route.query.isHistory
      this.getGameplanConfigFull()
    },
    gotoWeb(buName,buCode){
      this.$router.push({path:'/gameplan/quotaChange-approval-detail',query:{activityType:'01',buName,buCode,themeId:this.themeId}})
    },
    gotoConfirmedDetail(path){
      this.$router.push({path,query:{themeId:this.themeId}})
    },
    getName(str,index=0){
      if(str){
          return str.split('|')[index] || str
      }else return ''
    },
    addThemeInfo(){
      this.$router.push({ name:'configure-theme-info',query:{themeId:this.themeId} })
    },
    deleteThemeInfo(){
      this.$confirm('是否确定删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(async() => {
        const params = { themeId:this.themeId}
        const { data } = await gameplanApi.getGameplanThemeDeleteThemeInfo(params);
        if (data.resultCode === "0") {
          this.$alert('删除成功', '提示', {
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-red',
          });
          this.$router.go(-1)
        }
      }).catch(() => {
      });
    },
    async handleDelete(){
      const { data } = await gameplanApi.getGameplanThemeDeleteThemeInfo(this.themeId);
      if (data.resultCode === "0") {
        this.$alert('删除成功', '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'btn-red',
        });
      }
    },
    async getGameplanThemeChannelAssign(){
      const params = { themeId:this.themeId}
      const { data } = await gameplanApi.getGameplanThemeChannelAssign(params);
      if (data.resultCode === "0") {
        this.channelAssignVOS = data.resultData?.channelAssignVOS || []
      }
    },
    connectVendor(){
      this.$router.push({ name:'PO-connect',query:{themeId:this.themeId}})
    },
    handleChannelChange(channelCode,isChecked){
      if(isChecked){
        let selectedChannelList = []
        this.fullConfig.forEach(item=>{
          if(this.channelCodes.indexOf(item.themeChannelCode)!==-1){
            selectedChannelList.push(item.themeChannelCode)
          }
        })
        this.themeChannelCodes = selectedChannelList
      }else{
        this.$confirm('是否确定删除该渠道?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(() => {
          let params = {
            themeId:this.themeId,
            channelCode
          }
          this.gameplanThemeDelChannel(params)
        }).catch(() => {
          this.channelCodes = this.themeChannelCodes
        });
      }
    },
    async gameplanThemeDelChannel(params){
      //console.log(params);
      const { data } = await gameplanApi.gameplanThemeDelChannel(params);
      if (data.resultCode === "0") {
        const index = this.themeChannelCodes.indexOf(params.channelCode)
        this.themeChannelCodes.splice(index,1)
        this.$alert('删除成功', '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'btn-red',
        });
      }
    },
    getChannelConfig(themeChannelCode){
      return this.fullConfig.find(val=>{
        return themeChannelCode===val.themeChannelCode
      })
    },
    getSaveInfo(themeChannelCode){
      const data = this.saveDetailList.filter(val=>{
        return themeChannelCode===(val.themeDetail?.themeChannelCode)
      })
      return data || {}
    },
    getSaveChannelSkuDTOList(themeChannelCode){
      // console.log(this.saveChannelSkuDTOList);
      const data = this.channelSkuDTOList.find(val=>{
        return themeChannelCode===(val.channelCode)
      })
      return data || {}
    },
    handleReceiveDetail(data,itemKey){
      this.themeChannelChecked.push(itemKey)
    },
    handleStyleChange(themeStylesList,themeChannelCode){
      this.$nextTick(function () {
        let styleInfo = this.detailList[themeChannelCode] || {}
        let styleCodeList = Object.keys(styleInfo)
        styleCodeList.forEach(item=>{
          if(themeStylesList.indexOf(item)===-1){
            this.$delete(styleInfo,item)
          }
        })
      });
    },
    getShowDetail(){
      let brandInfo = []
      let prInfo = []
      const gpPrDTOList = this.themeBasic.gpPrDTOList
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          let data = ''
          if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
          else data = item.brandName||item.subBrandName
          if(brandInfo.indexOf(data)===-1) {
            brandInfo.push(data)
          }
          prInfo.push(item.prNumber+'-'+item.prName)
        })
        this.brandInfo = brandInfo.join('、')
        this.prInfo = prInfo.join('、')
      }
    },
    async getGameplanThemeInfo(themeId,type,detailOrConfig) {
      this.loading = true
      let params = {
        themeId,
        detailOrConfig
      }
      const { data } = await gameplanApi.getGameplanThemeInfo(params);
      if (data.resultCode === "0") {
        this.saveDetailList = data.resultData?.themeInfo.detailList || []
        this.channelSkuDTOList = data.resultData?.themeInfo.channelSkuDTOList || []
        this.btmpSkuDTOList = data.resultData?.themeInfo.btmpSkuDTOList || []
        if(type==='themeId'){
          this.themeBasic = data.resultData?.themeInfo.themeBasic || {}
          this.getShowDetail()
        }
        this.saveDetailList.forEach(item=>{
          this.themeChannelCodes.indexOf(item.themeDetail.themeChannelCode)===-1?this.themeChannelCodes.push(item.themeDetail.themeChannelCode):''
          if(item.themeDetail.themeDetailStatus && type==='themeId'){
            this.themeChannelChecked.indexOf(item.themeDetail.themeChannelCode)===-1?this.themeChannelChecked.push(item.themeDetail.themeChannelCode):''
          }
        })
        this.channelCodes = this.themeChannelCodes
      }
      this.loading = false
    },
    async getGameplanConfigFull() {
      this.loading = true
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.fullConfig = data.resultData?.fullConfig || [];
        //this.assignBuList = data.resultData?.assignBuList || []
        //this.assignRegionList = data.resultData?.assignRegionList || []
        //this.assignAreaList = data.resultData?.assignAreaList || []
        //this.total = data.resultData.pageInfo.totalCounts
      }
      if(this.themeId){
        this.getGameplanThemeInfo(this.themeId,'themeId',1)
      }
      if(this.historyThemeId) {
        this.getGameplanThemeInfo(this.historyThemeId,'history',2)
      }
    },
    // 上传文件
    getManualFileId (file) {
      this.themeBasic.manualFileId = file.fileId
    },
    getExecTemplateId (file) {
      this.themeBasic.execTemplateId = file.fileId
    },
    openFile(type){
      if(type === 'execTemplateUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.execTemplateUri))
      }else if(type === 'manualFileUri'){
        window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
      }
    },
    // 删除文件
    clearManualFileId (file) {
      this.themeBasic.manualFileId = ''
      this.errorList = []
    },
    clearExecTemplateId (file) {
      this.themeBasic.execTemplateId = ''
      this.errorList = []
    },
    submit(){
      this.loading = true
      this.valid = true
      this.showConfirmDialog=false
      this.detailList = []
      this.rateErrorList = []

      this.themeBasic.themeChannelCodes=this.themeChannelCodes
      this.themeBasic.applyStartTime = this.themeBasic.applyTime[0]
      this.themeBasic.applyEndTime = this.themeBasic.applyTime[1]
      this.themeBasic.themeStartTime = this.themeBasic.themeTime[0]
      this.themeBasic.themeEndTime = this.themeBasic.themeTime[1]
      this.themeBasic.prNumber? '' : this.themeBasic.prNumber = this.$route.query.prNumber
      this.themeBasic.buToCity = 0
      this.themeBasic.themeId = this.themeId
      if(this.employeeLevel>=90){
        this.themeBasic.orgLevel = 'hq'
      }else if(this.employeeLevel>=60&& this.employeeLevel<90){
        this.themeBasic.orgLevel = 'bu'
      }else if(this.employeeLevel>=45&& this.employeeLevel<60){
        this.themeBasic.orgLevel = 'region'
      }
      if(this.$refs.configItemRef&&this.$refs.configItemRef.length>0){
        for(let i=0;i<this.$refs.configItemRef.length;i++){
          this.$refs.configItemRef[i].submit(this.operateType)
          //this.$refs.configDetailRef[i].submit()
        }
      }
      let data = {
        detailList:this.detailList,
        themeBasic:this.themeBasic
      }
      if(this.valid){
        this.operateType ==='save'?this.handleGetGameplanThemeSave(data):this.getGameplanThemeSubmit(data)
      }else {
        this.loading = false
        this.$alert(`${this.rateErrorList.length>0?this.rateErrorList.join('、')+'活动形式比例未填写，':'页面有必填数据未填写，'}请填写后重新提交！`, '提示', {
          confirmButtonText: '确定',
          confirmButtonClass: 'btn-red',
          callback: () => {
          }
        });
      }
    },
    handleSubmit(item,valid,type){
      if(!valid){
        this.valid = false
      }
      //console.log(valid,type);
      if(type){
        if(this.rateErrorList.indexOf(type)==-1){
          this.rateErrorList.push(type)
        }
      }
      this.detailList.push(item)
    },
    handleOperation(type){
      this.operateType = type
      this.$confirm(`是否要${this.operateType==='submit'?'提交':'保存'}当前数据？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          this.submit()
        }).catch(() => {
        });
      //this.showConfirmDialog=true
    },
    handleAddTime(data){
      // console.log(data);
      // console.log(this.themeBasic.themeTime);
      //this.confirmed = false
      // if(oldv.length===0&&val!==oldv){
      //   this.$confirm(`修改执行时间后转场配额信息将被清空，是否确认修改执行时间？`, '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     confirmButtonClass: 'btn-red',
      //     type: 'warning'
      //   }).then(async() => {

      //   }).catch(() => {
      //   });
      // }
      this.$store.commit('SET_THEME_TIME',data)
    },
    handleGetGameplanThemeSave(data){
      if(Object.keys(this.themeInfo).length === 0){
        this.getGameplanThemeSave(data)
      }else {
        this.getGameplanThemeSaveUpdate(data)
      }
    },
    async getGameplanThemeSave(data) {
      //console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSave(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
    async getGameplanThemeSaveUpdate(data) {
      //console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSaveUpdate(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
    async getGameplanThemeSubmit(data) {
      //console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSubmit(data);
      if (res.data.resultCode === "0") {
        this.$message.success("提交成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #a3a3a3 !important;
    border-color: #DCDFE6 !important;
    color: rgb(255, 255, 255) !important;
    cursor: not-allowed;
}
::v-deep .el-checkbox {
    &.is-checked {
      .el-checkbox__inner {
        &::after {
          border-color: #ffffff;
        }
      }
    }
  }
  ::v-deep .configure-execution .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #edf2fc !important;
    border-color: #DCDFE6 !important;
    color: rgb(255, 255, 255) !important;
    cursor: not-allowed;
}
  ::v-deep .configure-execution .el-checkbox__input.is-checked .el-checkbox__inner,
 .configure-execution .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #a3a3a3!important;
  border-color: #c0c0c0 !important;
}
.check-item{
  margin-right: 40px;
}
.channelAssign-box{
  display: flex;
  flex-direction: column;
}
.channelAssign{
  font-size: 14px;
  display: flex;
  margin:5px 0 5px 30px;
}
.channelAssign-item{
  margin-left: 30px;
  font-weight: 500;
}
.channelAssign-link{
  color: #409eff;
  font-weight: 500;
  margin-left: 100px;
  cursor: pointer;
}
.pr-box{
  width: calc(100% - 50px);
  padding: 15px 25px 15px 25px;
  background-color: #ffffff;
  border-radius: 8px;
  .pr-item{
    display: flex;
    flex-wrap: wrap;
    //margin-bottom: 12px;
  }
  .space-between{
    justify-content: space-between;
  }
  .flex{
    display:flex;
    flex-wrap:wrap;
  }
  .pr-title{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
  .pr-level{
    color: white;
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    padding: 0 10px;
    background-color: rgb(71, 172, 255);
  }
  .pr-status {
    color: rgb(192, 1, 1);
    font-size: 16px;
    font-weight: 600;
  }
}
.operation_btn_box{
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: flex-end;
  top: 0px;
  .operate_btn{
    text-align: center;
    padding: 5px 12px;
    border-radius: 4px;
    margin: -5px 0  0 10px;
    cursor: pointer;
  }
  .operate_btn_red {
    color: white;
    background-color: rgb(214, 0, 0);
  }
  .operate_btn_white{
    color: rgb(214, 0, 0);
    background-color: white;
    border: 1px solid rgb(214, 0, 0);
  }
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409eff;
  border-color: #409eff;
}

::v-deep .el-checkbox__inner:hover,
::v-deep .el-checkbox__input .el-checkbox__inner:focus {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .el-checkbox__input.is-focus .el-checkbox__inner:hover {
  border-color: #409eff !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #101010;
}

::v-deep .activity_new .el-form-item {
  min-width: 48%;
  margin-bottom: 24px;

  .el-form-item__label {
    color: black;
  }
}
::v-deep .el-checkbox__input {
    margin-top: -8px;
}

::v-deep .el-checkbox__label {
    margin-top: -2px;
}
.content-wrapper {

  .activity_new {
    position: relative;
    margin-top: -50px;

    .activity-new-card {
      padding: 20px 10px 20px 0px;
      background-color: #ffffff;
      color: #101010;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      font-family: SourceHanSansSC-bold;
      display: flex;
      justify-content: flex-start;

      .po_config_btn {
        cursor: pointer;
        position: absolute;
        right: 0;
        top: -25px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: #539efe;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        font-family: Roboto;
      }
    }

    .activity_channel_checkbox {
      margin: -5px 0 20px 40px;
      display: flex;
    }

    .activity_channel_checkbox_label {
      text-align: center;
      position: relative;
      top: 15px;
      line-height: 18px;
    }
  }
}

.upload_section {
  margin: 30px 0 0 8px;
  font-size: 12px;
}
.upload_item {
    display: flex;
    margin-left: 30px;
  }

  .upload_item_title {
    width: 220px;
    font-size: 14px;
    font-weight: 600;
    padding: 20px 10px;
  }

  .upload_item_btn {
    cursor: pointer;
    margin-top: 13px;
    height: 30px;
    line-height: 30px;
    width: 100px;
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;
    color: white;
    background-color: rgb(204, 0, 0);
  }

.btn_section{
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin-top: 60px;
  .normal_btn{
    width: 100px;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }
  .btn_bg_white{
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    margin-right: 100px;
  }
  .btn_bg_white_disadled{
    border: 1px solid $base-grey4 !important;
    color: $base-grey4 !important;
    cursor: no-drop;
    margin-right: 100px;
  }
  .btn_bg_red{
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
  .btn_bg_red_disabled{
    color: white;
    cursor: no-drop;
    background-color: $base-grey4 !important;
    border: 1px solid $base-grey4 !important;
  }
}
</style>
